import {BaseValidatedClass} from './BaseValidatedClass';

interface ExternalImageLibraryMap {
  openImageLibrary(
    _currentImageUrl: string,
    _onImageSelectCallback: ExternalGalleryImageSelectCallback,
    _onCancelCallback: ExternalGalleryImageCancelCallback
  ): void;

}
export interface ExternalGalleryImage {
  originalName: string; // 'YOUR_FILE_NAME.png'
  width: number; // width in pixels
  height: number; // height in pixels
  sizeBytes: number; // size in bytes
  url: string; // 'https://YOUR_STORAGE_URL/YOUR_FILE.png'
  altText: string;
  labels?: Record<string, string>; // Optional key-value pairs for image metadata
}

export type ExternalGalleryImageSelectCallback = (imageUrl: ExternalGalleryImage) => void;
export type ExternalGalleryImageCancelCallback = () => void;

export class ExternalImageLibrary extends BaseValidatedClass implements ExternalImageLibraryMap {
  /** List of methods that must be implemented by subclasses */
  private static readonly REQUIRED_METHODS: (keyof ExternalImageLibraryMap)[] = ['openImageLibrary'];

  constructor() {
    super(ExternalImageLibrary.REQUIRED_METHODS, ExternalImageLibrary);
  }

  public openImageLibrary(_currentImageUrl: string, _onImageSelectCallback: ExternalGalleryImageSelectCallback, _onCancelCallback: ExternalGalleryImageCancelCallback): void {
    throw new Error('Method openImageLibrary() must be implemented by the subclass');
  }
}
